<template>
  <div class="app-notification" :class="`app-notification-${level}`">
    <Icon :name="iconName" />
    <div class="app-notification-content">
      <div class="app-notification-title">{{ title }}</div>
      <div class="app-notification-description" v-if="description">{{ description }}</div>
    </div>
    <div class="app-notification-actions">
      <a class="app-notification-detail" v-if="detailUrl" :href="detailUrl" target="_blank" rel="noopener noreferrer"
        >詳細</a
      >
      <button class="app-notification-close" type="button" aria-label="閉じる" @click="close">
        <Icon name="close" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, SetupContext } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'

import { PropLevelType } from './types'

const ICON_NAMES: Record<PropLevelType, string> = {
  info: 'information-outline',
  danger: 'alert-circle-outline'
}

export default defineComponent({
  name: 'AppNotification',
  components: {
    Icon
  },
  emits: ['close'],
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    level: {
      type: String as PropType<PropLevelType>,
      default: 'info'
    },
    detailUrl: {
      type: String,
      default: ''
    }
  },
  setup(props, context: SetupContext) {
    const iconName = computed(() => ICON_NAMES[props.level])

    const close = () => context.emit('close')

    return {
      iconName,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.app-notification {
  display: flex;
  gap: $spacing-unit * 2;
  align-items: center;
  padding: $spacing-unit $spacing-unit * 2;
  font-size: $font-size;
  line-height: 20px;
}

.app-notification-info {
  color: $text-color-white;
  background-color: $info-color;
}

.app-notification-danger {
  color: $text-color-white;
  background-color: $danger-color;
}

.app-notification-content {
  flex: 1;
  min-width: 0;
}

.app-notification-title {
  font-weight: bold;
}

.app-notification-description {
  margin-top: $spacing-unit * 0.5;
}

.app-notification-actions {
  display: flex;
  gap: $spacing-unit * 2;
  align-items: center;
}

.app-notification-detail {
  flex-shrink: 0;
  padding: $spacing-unit * 0.5 $spacing-unit * 2;
  font-size: 12px;
  color: inherit;
  text-decoration: none;
  border: 1px solid currentcolor;
  border-radius: $round;
}

.app-notification-close {
  display: flex;
  padding: 0;
  color: inherit;
  cursor: pointer;
  background: none;
  border: none;
}
</style>
